<template>
  <div class="replenishment-iframe">
    <iframe
      ref="replenishmentIframe"
      :src="iframeSrc"
    />
    <fix-bottom>
      <template slot="button">
        <a-button
          type="primary"
          @click="toList"
        >返回列表</a-button>
      </template>
    </fix-bottom>
  </div>
</template>


<script>
import FixBottom from '@/components/fix-bottom/index.vue';
import CryptoJS from "crypto-js";
import qs from "qs";
import { random, clone } from "lodash";
import env from '../../../../../env/index'
import getQueryString from '../utils'

export default {
  name: 'ReplenishmentIframe',
  components: {
    FixBottom
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      iframeSrc: '',
      appKey: env.appKey,
      secretKey: env.secretKey,
    }
  },
  created() {
    this.iframeSrc = `${env.REPLENISHMENT}public/purchase/intelligent-replenish?customerCode=${this.customerCode}`
  },
  mounted() {
    // 监听商流页面返回的消息
    window.addEventListener("message", this.handleMessage, false);
  },
  methods: {
    generateSign(uri, params) {
      const query = `${uri}_${qs.stringify(params).replaceAll('&', '_')}_${this.secretKey}`
      const encodeQuery = encodeURIComponent(query)
     const sign = CryptoJS.MD5(encodeQuery).toString();
      return sign;
    },
    handleMessage(event) {
      const {data} = event;
      if (data) {
        const { uris } = data;
        if (Array.isArray(uris)) {
          uris.map(uri => {
            const item = uri
            const params = {};
            params.appkey = this.appKey;
            params.customerCode = getQueryString( "customerCode", this.iframeSrc);
            params.rd = random(10000, 100000);
            params.ts = Date.now();
            params.sign = this.generateSign(item.path, clone(params));
            item.params = params
            return item
          })
        }
        const {replenishmentIframe} = this.$refs
        replenishmentIframe.contentWindow.postMessage({uris}, "*")
      }
    },
    toList() {
      this.$emit('changeType', this.index)
    }
  }
}
</script>

<style lang="less" scoped>
.replenishment-iframe {
  background: #fff;
  border-radius: 6px;
  padding: 24px;
  height: calc(100vh - 200px);
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
